module.exports = __webpack_public_path__ + "static/media/injured-player.svg.4ebde806.png";